import { useMemo } from 'react';
import { LANGUAGES } from '@/shared/i18n/resources';
import { languageTradPrefix } from './tradPrefix';

export const useLanguageOptions = () =>
	// LANGUAGES is a static, module-level constant, so this never needs to recompute.
	useMemo(() => LANGUAGES.map((lang) => ({ label: `${languageTradPrefix}.${lang}`, value: lang })), []);
